// extracted by mini-css-extract-plugin
module.exports = {"Layouter":"styles_Layouter__10QqR","staticFooter":"styles_staticFooter__qEsJD"};